// src/components/ServerDataExtraction/ExtractionHistory.jsx
import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const ExtractionHistory = ({
  history = [],
  isLoading = false,
  error = null,
  onClearHistory,
  onSelectHistoryItem
}) => {
  const { language } = useLanguage();
  const isEn = language === 'en';

  return (
    <div className="glass-card history-card">
      <div className="card-header-line">
        <div className="card-title-wrap">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" />
            <polyline points="12 6 12 12 16 14" />
          </svg>
          <h3 className="card-title">
            {isEn ? 'Extraction History' : 'История извлечения'}
          </h3>
        </div>
        {history && history.length > 0 && (
          <button
            type="button"
            className="history-btn-sm"
            onClick={onClearHistory}
            title={isEn ? 'Clear history' : 'Очистить историю'}
          >
            <svg viewBox="0 0 24 24">
              <polyline points="3 6 5 6 21 6" />
              <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
            </svg>
            <span>{isEn ? 'Reset' : 'Сброс'}</span>
          </button>
        )}
      </div>

      <div className="history-list">
        {isLoading ? (
          <div className="history-empty">
            <span className="inline-block w-4 h-4 border-2 border-white/20 border-t-white rounded-full animate-spin mr-2 align-middle"></span>
            <span>{isEn ? 'Loading history...' : 'Загрузка истории...'}</span>
          </div>
        ) : error ? (
          <div className="history-empty text-red-400">
            {error}
          </div>
        ) : !history || history.length === 0 ? (
          <div className="history-empty">
            {isEn ? 'Extraction history is empty' : 'История извлечений пуста'}
          </div>
        ) : (
          history.map((item, idx) => {
            const hostDisplay = item.host || item.server || item.ip || 'Unknown Server';
            const timeDisplay = item.time || item.date || (isEn ? 'Recently' : 'Только что');
            const playersCount = item.players !== undefined
              ? (typeof item.players === 'number' ? item.players.toLocaleString() : item.players)
              : (item.onlinePlayers !== undefined ? item.onlinePlayers.toLocaleString() : null);
            const formatDisplay = (item.format || item.outputFormat || 'JSON').toUpperCase();

            return (
              <div key={item.id || idx} className="history-item">
                <div className="history-item-main">
                  <span className="history-item-host">{hostDisplay}</span>
                  <div className="history-item-meta">
                    <span>{timeDisplay}</span>
                    {playersCount !== null && (
                      <>
                        <span>&bull;</span>
                        <span>{playersCount} {isEn ? 'players' : 'игроков'}</span>
                      </>
                    )}
                    <span>&bull;</span>
                    <span className="text-white font-bold">{formatDisplay}</span>
                  </div>
                </div>

                <div className="history-item-actions">
                  <button
                    type="button"
                    className="history-btn-sm"
                    onClick={() => onSelectHistoryItem && onSelectHistoryItem(item)}
                  >
                    {isEn ? 'Open' : 'Открыть'}
                  </button>
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default ExtractionHistory;